import React, { memo } from 'react';
import classNames from 'classnames';
import { required } from '../../../util/validators';
import { FieldTextInput, MediaUpload } from '../../../components';
import DateOfBirthField from './DateOfBirthField';
import UserNameField from './UserNameField';
import FanTeamSelection from './FanTeamSelection';
import FanAddressFormFields from './FanAddressFormFields';
import defaultFanAvatar from '../../../assets/defaultFanAvatar.png';
import css from './SignupForm.module.css';

const FanProfileFormFields = memo(
  ({ intl, formId, values = {}, form, handleBioChange, remainingChars, bio }) => {
    const { userType } = values;

    return (
      <div className={css.fanProfileFormFields}>
        <UserNameField intl={intl} formId={formId} />

        <DateOfBirthField
          name="dateOfBirth"
          label={intl.formatMessage({
            id: 'SignupForm.FanProfileFormFields.dateOfBirthLabel',
          })}
          placeholder={intl.formatMessage({
            id: 'SignupForm.FanProfileFormFields.dateOfBirthPlaceholder',
          })}
          validate={required(
            intl.formatMessage({
              id: 'SignupForm.FanProfileFormFields.dateOfBirthRequired',
            })
          )}
        />

        <FanAddressFormFields intl={intl} />

        <div className={css.bioSection}>
          <FieldTextInput
            type="textarea"
            id={`${formId}-description`}
            name="description"
            value={bio}
            onChange={handleBioChange}
            label={intl.formatMessage({
              id: 'SignupForm.FanProfileFormFields.aboutMeLabel',
            })}
            placeholder={intl.formatMessage({
              id: 'SignupForm.FanProfileFormFields.aboutMePlaceholder',
            })}
          />
          <div
            className={classNames(css.characterCount, {
              [css.warning]: remainingChars < 10 && remainingChars > 0,
              [css.limitReached]: remainingChars === 0,
            })}
          >
            {remainingChars}{' '}
            {intl.formatMessage({
              id: 'SignupForm.descriptionCharactersLeft',
            })}
          </div>
        </div>

        <div className={css.uploadSection}>
          <MediaUpload
            form={form}
            fieldName="profilePicture"
            acceptedTypes={{
              'image/jpeg': [],
              'image/png': [],
            }}
            multiple={false}
            heading={intl.formatMessage({
              id: 'SignupForm.FanProfileFormFields.profilePictureHeading',
            })}
            description={intl.formatMessage({
              id: 'SignupForm.FanProfileFormFields.profilePictureDescription',
            })}
            userType={userType}
            values={values}
            defaultFanAvatar={defaultFanAvatar}
            isFanRegistrationForm={true}
          />
        </div>

        <FanTeamSelection
          intl={intl}
          formId={formId}
          validate={required(
            intl.formatMessage({
              id: 'Signupform.FanProfileFormFields.favoriteProfessionalTeamsRequired',
            })
          )}
        />
      </div>
    );
  }
);

export default FanProfileFormFields;
